import {Group, Image, Rect, Text} from "react-konva";
import {useStage} from "@/components/konva/stage/ResponsiveStageHooks.ts";
import {useEncounterViewPort} from "@/encounter/viewport/EncounterViewPortHooks.ts";
import type {Visibility} from "./VisibilityModel.ts";
import {fogPlacementInWorld, placeFogFrame, uncoveredFogRegions} from "./SoftFogPlacement.ts";
import {useFogMask} from "./useFogMask.ts";

// The player mask remains exact; only its presentation on the editable GM map is lighter.
export default function GameMasterSightMask({visibility, opacity}: {visibility: Visibility; opacity: number}) {
    const {mapTransform} = useEncounterViewPort();
    const {stageSize} = useStage();
    const {frame, unavailable} = useFogMask(visibility, mapTransform);
    if (!visibility.enabled) return null;

    if (unavailable) return <Text x={(24 - mapTransform.x) / mapTransform.scale}
                              y={(24 - mapTransform.y) / mapTransform.scale}
                              scaleX={1 / mapTransform.scale} scaleY={1 / mapTransform.scale}
                              text="Spielersicht-Maske nicht verfügbar" fill="#fca5a5"
                              fontSize={16} listening={false}/>;

    const placement = frame ? placeFogFrame(frame.scene, mapTransform) : undefined;
    const uncovered = uncoveredFogRegions(stageSize, placement);
    return <Group listening={false}>
        {uncovered.map((region, index) =>
            <Rect key={index} {...fogPlacementInWorld(region, mapTransform)}
                  fill="#080c14" opacity={opacity} listening={false}/>)}
        {frame && placement && <Image image={frame.bitmap}
                                     {...fogPlacementInWorld(placement, mapTransform)}
                                     opacity={opacity} listening={false}/>}
        {frame && placement && <Image image={frame.tintBitmap}
                                     {...fogPlacementInWorld(placement, mapTransform)}
                                     globalCompositeOperation="lighter" listening={false}/>}
    </Group>;
}
